export default __webpack_public_path__ + "static/media/Fitness-Workout.3613a1c3.png";